import { cva, type VariantProps } from 'class-variance-authority';
import type {ComponentProps, ReactNode } from 'react';

import { cn } from './cn';

const badgeVariants = cva(
	'inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-[11px] font-semibold',
	{
		variants: {
			tone: {
				neutral: 'bg-surface-muted text-fg-muted border border-border',
				copart: 'bg-primary/10 text-primary border border-primary/20',
				iaai: 'bg-accent/15 text-accent-fg border border-accent/30',
				success: 'bg-success/12 text-success border border-success/25',
				warning: 'bg-warning/15 text-warning border border-warning/30',
				overlay: 'bg-black/65 text-white backdrop-blur-sm',
			},
		},
		defaultVariants: { tone: 'neutral' },
	},
);

type BadgeProps = ComponentProps<'span'> & VariantProps<typeof badgeVariants>;

export function Badge({ className, tone, ...props }: BadgeProps): ReactNode {
	return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}
